var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymCheckList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.656 6.943h15.1v2h-15zm0 8h15.1v2h-15z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.656,
    cy: 23.943,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.656 22.943h15.1v2h-15zM6.556 10.343l-.7-.8-1.5-1.5.7-.7 1.5 1.5 3.6-3.8.8.8-3.7 3.7-.7.8zm.4 8.1l-.7-.8-1.5-1.5.8-.7 1.4 1.5 3.7-3.7.7.7-3.6 3.7-.8.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymCheckList);
export default __webpack_public_path__ + "static/media/BYM_checkList.f33072c6.svg";
export { ForwardRef as ReactComponent };